import React from 'react'
import { Route } from 'react-router'
const RedirectBackLandingPage = React.lazy(() => import('@/modules/banking/components/redirect-back-landing-page'))
const BankingMasterDetail = React.lazy(() => import('@/modules/banking/components/list/banking-master-detail'))
const DirectDebitTransactionsPage = React.lazy(() => import('./components/direct-debit-transactions/direct-debit-transactions-page'))

const bankingRoutes = (
  <>
    <Route path='banking' Component={BankingMasterDetail} handle={{ options: { noBackgroundColor: true } }} />
    <Route path='banking/direct-debit-transactions' Component={DirectDebitTransactionsPage} />
    {/* redirect back routes for landingpages */}
    <Route path='landing/banking/finalized' Component={RedirectBackLandingPage} />
  </>
)

export default bankingRoutes
